/**
 * 請求関連 UI（設定の請求一覧メニュー、ホームの未確認請求ダイアログ等）の表示。
 * true にすると従来どおり表示されます。
 */
export const SHOW_INVOICE_UI = false;
